import React from 'react';
import ccss from "../../Styles/common.module.css";
import { observer } from 'mobx-react-lite';
import { ProductName } from "../../Styles/ProductName";
import { isRunningOnWebsite, PageName, WindowRoutingStateContext } from './WindowRoutingState';
import { DbRecordingsTableCached } from '../../State/EvidenceDB/DbRecordingsTableCached';
import { GlobalContext } from './GlobalContext';
import classNames from "./NavigationHeaderView.module.css";


const PageNavigationButton = observer( ({page, children}: React.PropsWithChildren<{page: PageName}>) => {
	const windowRoutingState = React.useContext(WindowRoutingStateContext);
	if (windowRoutingState == null) return null;
//	const selected = windowRoutingState.page === page;
	return (
		<div
			className={[
				classNames.HeaderNavigationElement,
				// ...(selected ? ['selected'] : [])
			].join(' ')}
			onClick={() => { windowRoutingState.pushPath(`/${page}`) }}
		>{
			children
		}</div>
	)
});

export const NavigationHeaderView = observer( () => {
	const windowRoutingState = React.useContext(WindowRoutingStateContext);
	const globalContext = React.useContext(GlobalContext);
	if (windowRoutingState == null || globalContext == null) return null;
	const {licenseCache} = globalContext;
	const recordingsTableCached = DbRecordingsTableCached.instance;
	const numberOfRecordingsInTheDatabase = recordingsTableCached?.recordings?.length ?? 0;
	const thereAreRecordingsInTheDatabase = numberOfRecordingsInTheDatabase > 0;
	const {recordingPanelState} = windowRoutingState;
	const recordingNameOrDescription = recordingPanelState?.recordingNameOrDescription;
	const [nameInEditBox, setNameInEditBox] = React.useState<string | undefined>();
	const saveName = () => {
		if (nameInEditBox != null) {
			console.log(`Changing name to ${nameInEditBox}`);
			recordingPanelState?.setRecordingName(nameInEditBox);
			setNameInEditBox(undefined);
		}
	}
	const cancelNameEdit = () => {
		setNameInEditBox(undefined);
	}
	const goToRecordingsPage = () => {
		if (window.history.length > 1 && windowRoutingState.typedPathTop === 'recordings' && windowRoutingState.recordingPanelState != null) {
			window.history.back()
		} else {
			windowRoutingState.pushPath("/recordings");
		}
	}
	const selected = windowRoutingState.page === 'recordings'
	return (<>
		<header className={classNames.PageHeaderElement}>
			<div className={classNames.HeaderRow}>
				<div className={classNames.HeaderColumn}>
					{ thereAreRecordingsInTheDatabase ? (<>
						<div
							className={[
								classNames.BreadcrumbElementBack,
								...(selected ? ['selected'] : [])
							].join(' ')}
							onClick={goToRecordingsPage}
						>{numberOfRecordingsInTheDatabase} Recordings
						</div>
							{ recordingPanelState == null ? null : (<>
								<div>→</div>
								<div className={classNames.BreadcrumbElementCurrent}>
									{ nameInEditBox != null ?  (<>
										<input type='text' className={classNames.NameInput}
											defaultValue={nameInEditBox}
											placeholder={recordingNameOrDescription}
											onChange={ (e) => setNameInEditBox(e.currentTarget.value) }
											onKeyDown={ (e) => { if (e.key === 'Enter') { saveName(); } } }
											/>
										<button className={ccss.borderless} onClick={ saveName }>✓</button>
										<button className={[ccss.borderless, ccss.redOnHover].join(" ")} onClick={ cancelNameEdit }>✗</button>
									</>) : recordingNameOrDescription }
									<button className={ccss.borderless} 
										hidden={ nameInEditBox != null }
										onClick = { () => setNameInEditBox(recordingPanelState.recordingName ?? "")
									}>✎</button>					
								</div>
							</>)}
					</>) : (<PageNavigationButton page={''}><ProductName/></PageNavigationButton>) }
				</div>
				<div className={classNames.HeaderColumn}>
					{ windowRoutingState.runningInExtension ? null : (
						<PageNavigationButton page={''}>⌂</PageNavigationButton>
					)}
					{ (isRunningOnWebsite && licenseCache.mayGenerateCausationGraph === false) ? null : (
						<PageNavigationButton page={'settings'} >⚙️</PageNavigationButton>
					)}
					<PageNavigationButton page={'license'} >📝</PageNavigationButton>
				</div>
			</div>
		</header>
		</>)
});
